import React, { useMemo } from 'react'
import { Content } from '@/components'
import { useQuery } from '@tanstack/react-query'
import { FileArrowDown } from 'phosphor-react'

import { getShipmentNoShows } from '@/http/getShipmentNoShows'
import { DataGrid } from '@mui/x-data-grid'
import { Box, Button, Card, CardContent } from '@material-ui/core'
import { TABLE_CONFIG } from '@/lib/Mui/x-data-grid'
import formatter from '@/services/formatter'
import { convertJsonToXlsx } from '@/utils/convert-json-to-xlsx'

export default function QueryNoShowPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['shipment_no_shows'],
    queryFn: () => getShipmentNoShows(),
  })

  const exportData = useMemo(() => {
    if (!data) return []

    return data.map((item) => ({
      CARGA: item.carga,
      'CRIAÇÃO DA COLETA': item.data_registro
        ? formatter(item.data_registro).toSimpleDate()
        : '',
      'DATA AGENDADA': item.data_coleta
        ? formatter(item.data_coleta).toSimpleDate()
        : '',
      'DATA CANCELAMENTO': item.data_canc
        ? formatter(item.data_canc).toSimpleDate()
        : '',
      'CLIENTE RAZÃO': item.cliente_razao,
      'CLIENTE CIDADE': item.cliente_municipio,
      'CLIENTE ESTADO': item.cliente_estado,
      'REPRESENTANTE - RAZÃO SOCIAL': item.repres_razao,
      PEDIDO: item.pedido,
      'PRODUTO CÓDIGO': item.produto_cod,
      'PRODUTO DESCRIÇÃO': item.prod_desc,
      'QUANTIDADE M²': item.quant_m2,
      'CANAL DESCRIÇÃO': item.canal_desc,
    }))
  }, [data])

  const handleExport = () => {
    if (!exportData) return

    convertJsonToXlsx(exportData, `consulta-no-show-${Date.now()}`)
  }

  return (
    <Content showReturn title="Consultar NoShow">
      <Card>
        <Box
          component={CardContent}
          height="80vh"
          display="flex"
          flexDirection="column"
        >
          <Box display="flex" justifyContent="flex-end" mb={1}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<FileArrowDown />}
              onClick={handleExport}
              disabled={!data || isLoading}
            >
              Exportar
            </Button>
          </Box>

          <DataGrid
            density="compact"
            localeText={TABLE_CONFIG.LOCALIZATION}
            pageSizeOptions={TABLE_CONFIG.PAGE_SIZE_OPTIONS}
            rows={data || []}
            loading={isLoading}
            columns={[
              { headerName: 'CARGA', field: 'carga', minWidth: 120 },
              {
                headerName: 'CRIAÇÃO DA COLETA',
                field: 'data_registro',
                valueFormatter: ({ value }) => formatter(value).toSimpleDate(),
                minWidth: 140,
              },
              {
                headerName: 'DATA AGENDADA',
                field: 'data_coleta',
                valueFormatter: ({ value }) => formatter(value).toSimpleDate(),
                minWidth: 140,
              },
              {
                headerName: 'DATA CANCELAMENTO',
                field: 'data_canc',
                valueFormatter: ({ value }) => formatter(value).toSimpleDate(),
                minWidth: 140,
              },
              {
                headerName: 'CLIENTE RAZÃO',
                field: 'cliente_razao',
                minWidth: 200,
              },
              {
                headerName: 'CLIENTE CIDADE',
                field: 'cliente_municipio',
                minWidth: 140,
              },
              { headerName: 'CLIENTE ESTADO', field: 'cliente_estado' },
              {
                headerName: 'REPRESENTANTE - RAZÃO SOCIAL',
                field: 'repres_razao',
                minWidth: 200,
                flex: 1,
              },
              { headerName: 'PEDIDO', field: 'pedido', minWidth: 140 },
              {
                headerName: 'PRODUTO CÓDIGO',
                field: 'produto_cod',
                minWidth: 140,
              },
              {
                headerName: 'PRODUTO DESCRIÇÃO',
                field: 'prod_desc',
                minWidth: 200,
              },
              {
                headerName: 'QUANTIDADE M²',
                field: 'quant_m2',
                type: 'number',
                minWidth: 140,
              },
              {
                headerName: 'CANAL DESCRIÇÃO',
                field: 'canal_desc',
                minWidth: 140,
                hide: true,
              },
            ]}
          />
        </Box>
      </Card>
    </Content>
  )
}
